<template>
  <div class="comment">
    <div class="userwrap">
      <div class="avatar"><img :src="comment.userIcon"></div>
      <div class="msg">
        <p class="name">{{comment.userName}}</p>
        <p class="date">{{comment.createTime | DateFilter('yyyy-MM-dd hh:mm')}}</p>
      </div>
      <span class="likes righticon">{{comment.likes}}</span>
      <i class="iconfont icon-dianzan righticon" :class='{ "active": amILike }' @click.stop='like'></i>
      <i class="iconfont icon-shanchu righticon" @click.stop='deleteItem' v-show='user.userId === comment.userId'></i>
    </div>
    <img :src="comment.thumb" class="widthFix" alt="">
    <p class="comment_value">{{comment.content}}</p>
  </div>
  
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast } from 'vant';

export default {
  data() {
    return {
      amILike: false,
      duration: 1500,
    };
  },
  props: {
    comment: {
      type: Object,
    },
    user: {
      type: Object,
    },
    isMine: { // 是否是自己的帖子（如果是，则可以删除所有评论,否则只能删除自己的评论）
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 点赞
    like() {
      this.$http.post(`${this.URL_PREFIX}/app/opt/bbs/likes/comments`, { 
        id: this.comment.id,
      }, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.amILike = !this.amILike;
          if (this.amILike) {
            this.comment.likes += 1;
          } else {
            this.comment.likes -= 1;
          }
        }
      });
    },
    // 删除
    deleteItem() {
      this.$http.post(`${this.URL_PREFIX}/app/delete/bbs/comments`, {
        id: this.comment.id,
      }, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.$emit('deleteComment', this.comment.id)
        } else {
          Toast.fail({ duration: this.duration, message:  res.resDesc});
        }
      });
    },
  },
  computed: {
    ...mapGetters(['token']),
  },
  created() {
    this.amILike = this.comment.isLikes ? true : false;
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.comment{
  padding: .4rem 0;
  border-bottom: 1px solid rgb(235, 235, 235);
  .userwrap{
    height: .8rem;
    line-height: .8rem;
    @include clear-float;
    .avatar{
      display: inline-block;
      margin-right: .213333rem;
      width: .8rem;
      height: .8rem;
      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .msg{
      display: inline-block;
      color: rgb(102, 102, 102);
      .name{
        font-size: .32rem;
        line-height: .48rem;
      }
      .date{
        font-size: .24rem;
        line-height: .48rem;
      }
    }
    .righticon{
      float: right;
      font-size: .266667rem;
      color: rgb(102,102,102);
      &.iconfont{
        font-size: .426667rem;
      }
      &.icon-shanchu{
        margin-right: .4rem;
      }
      &.icon-dianzan{
        margin-right: .16rem;
      }
      &.active{
        color: $color-main;
      }
    }
  }
  .comment_value{
    margin-top: .213333rem;
    font-size: .32rem;
    line-height: .64rem;
    color: rgb(102, 102, 102);
  }
  .widthFix{
    width: 100%;
    height: auto;
    object-fit: scale-down;
    margin: 10px 0;
  }
}

.comment_fade-enter-active, .comment_fade-leave-active {
  transition: opacity .5s;
}
.comment_fade-enter, .comment_fade-leave-to{
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/pages/bbs/components/child/CommentItem.vue